/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { i as isWeb, a as isKuaiShouMiniProgram, b as isWeChatMiniProgram, c as isByteDanceMicroApp, d as isMiniApp, e as isBaiduSmartProgram } from '../../../index-892d8eee.js';

function isUndef(type) {
  return type === 'undefined';
}

var isDingdingMiniapp = !isUndef(typeof dd) && dd !== null && !isUndef(typeof dd.alert);

var CONTAINER_NAME = {
  WECHAT: 'wechatMiniProgram',
  ALIPAY: 'aliMiniApp',
  BYTE: 'bytedanceMicroApp',
  WEB: 'web',
  BAIDU: 'baiduSmartProgram',
  KWAI: 'kuaishouMiniProgram'
};

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function promisify(api) {
  return function (arg) {
    return new Promise(function (resolve, reject) {
      var promisifyArg = arg;
      api(_extends$2({}, promisifyArg, {
        success: function success(res) {
          if (promisifyArg && typeof promisifyArg.success === 'function') {
            promisifyArg.success(res);
          }

          resolve(res);
        },
        onSuccess: function onSuccess(res) {
          if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
            promisifyArg.onSuccess(res);
          }

          resolve(res);
        },
        fail: function fail(res) {
          if (promisifyArg && typeof promisifyArg.fail === 'function') {
            promisifyArg.fail(res);
          }

          reject(res);
        },
        onFail: function onFail(res) {
          if (promisifyArg && typeof promisifyArg.onFail === 'function') {
            promisifyArg.onFail(res);
          }

          reject(res);
        },
        complete: function complete(res) {
          if (promisifyArg && typeof promisifyArg.complete === 'function') {
            promisifyArg.complete(res);
          }
        },
        onComplete: function onComplete(res) {
          if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
            promisifyArg.onComplete(res);
          }
        }
      }));
    });
  };
}

var _excluded = ["_ext"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var styleIn = function styleIn(options, baseName) {
  var _ref = options || {},
      _ref$_ext = _ref._ext,
      _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return _extends$1({}, rest, _ext[baseName] || {});
};

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * actionsheet返回值格式化
 * @param res
 */
var formatResponse = function formatResponse(res) {
  return {
    text: res.data != undefined ? res.data : res.text
  };
};
/**
 * actionsheet参数格式化
 * @param options
 */


function styleOptions(options) {
  return options ? _extends({}, options, {
    success: function success(res) {
      options.success && options.success(formatResponse(res));
    }
  }) : {};
}

function normalizeGet(api, containerName) {
  return function (args) {
    return promisify(api)(styleOptions(styleIn(args, containerName))).then(formatResponse);
  };
}
function normalizeSet(api, containerName) {
  return function (args) {
    return promisify(api)(styleIn(args, containerName));
  };
}

var getClipboard$5 = normalizeGet(function (args) {
  return isDingdingMiniapp ? dd.getClipboard(args) : my.getClipboard(args);
}, CONTAINER_NAME.ALIPAY);

var setClipboard$b = normalizeSet(function (args) {
  return isDingdingMiniapp ? dd.setClipboard(args) : my.setClipboard(args);
}, CONTAINER_NAME.ALIPAY);
var setClipboard$c = setClipboard$b;

var aliMiniAppModule = {
  getClipboard: getClipboard$5,
  setClipboard: setClipboard$c
};

var getClipboard$4 = normalizeGet(function () {
  throw new Error('Uni API: getClipboard不支持');
}, CONTAINER_NAME.WEB);

var setClipboard$9 = normalizeSet(function (args) {
  var _ref = args || {},
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text,
      _ref$success = _ref.success,
      success = _ref$success === void 0 ? function () {} : _ref$success,
      _ref$fail = _ref.fail,
      fail = _ref$fail === void 0 ? function () {} : _ref$fail,
      _ref$complete = _ref.complete,
      complete = _ref$complete === void 0 ? function () {} : _ref$complete;

  var textArea;

  var createTextArea = function createTextArea() {
    textArea = document.createElement('textArea');
    textArea.style.position = 'absolute';
    textArea.style.top = 0;
    textArea.style.opacity = 0;
    textArea.style.zIndex = -1;
    textArea.value = text;
    document.body.appendChild(textArea);
  };

  var selectText = function selectText() {
    textArea.setAttribute('readonly', '');
    textArea.select();
    textArea.setSelectionRange(0, textArea.value.length);
  };

  var copyToClipboard = function copyToClipboard() {
    document.execCommand('copy');
    textArea.remove();
  };

  try {
    createTextArea();
    selectText();
    copyToClipboard();
    success(text);
    complete(text);
    return text;
  } catch (error) {
    fail(error);
    complete(text);
  }
}, CONTAINER_NAME.WEB);
var setClipboard$a = setClipboard$9;

var webModule = {
  getClipboard: getClipboard$4,
  setClipboard: setClipboard$a
};

var getClipboard$3 = normalizeGet(function (args) {
  return wx.getClipboardData(args);
}, CONTAINER_NAME.WECHAT);

var setClipboard$7 = normalizeSet(function (args) {
  args.data = args.text;
  delete args.text;
  return wx.setClipboardData(args);
}, CONTAINER_NAME.WECHAT);
var setClipboard$8 = setClipboard$7;

var weChatModule = {
  getClipboard: getClipboard$3,
  setClipboard: setClipboard$8
};

var getClipboard$2 = normalizeGet(function (args) {
  return tt.getClipboardData(args);
}, CONTAINER_NAME.BYTE);

var setClipboard$5 = normalizeSet(function (args) {
  args.data = args.text;
  delete args.text;
  return tt.setClipboardData(args);
}, CONTAINER_NAME.BYTE);
var setClipboard$6 = setClipboard$5;

var bytedanceModule = {
  getClipboard: getClipboard$2,
  setClipboard: setClipboard$6
};

var getClipboard$1 = normalizeGet(function (args) {
  return ks.getClipboardData(args);
}, CONTAINER_NAME.KWAI);

var setClipboard$3 = normalizeSet(function (args) {
  args.data = args.text;
  delete args.text;
  return ks.setClipboardData(args);
}, CONTAINER_NAME.KWAI);
var setClipboard$4 = setClipboard$3;

var kuaiShouModule = {
  getClipboard: getClipboard$1,
  setClipboard: setClipboard$4
};

var getClipboard = normalizeGet(function (args) {
  return swan.getClipboardData(args);
}, CONTAINER_NAME.BAIDU);

var setClipboard$1 = normalizeSet(function (args) {
  args.data = args.text;
  delete args.text;
  return swan.setClipboardData(args);
}, CONTAINER_NAME.BAIDU);
var setClipboard$2 = setClipboard$1;

var baiDuModule = {
  getClipboard: getClipboard,
  setClipboard: setClipboard$2
};

var setClipboard = function setClipboard(args) {
  if (isWeb) {
    return webModule.setClipboard(args);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.setClipboard(args);
  } else if (isWeChatMiniProgram) {
    return weChatModule.setClipboard(args);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.setClipboard(args);
  } else if (isMiniApp) {
    return aliMiniAppModule.setClipboard(args);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.setClipboard(args);
  } else {
    throw new Error('Uni API：setClipboard暂不支持');
  }
};

var mini = setClipboard;

export { mini as default };
